import { useCallback, useRef, useState } from 'react';

export function DropZone({ onFile }: { onFile: (file: File) => void }) {
  const [dragging, setDragging] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFiles = useCallback(
    (files: FileList | null) => {
      const file = files?.[0];
      if (file) onFile(file);
    },
    [onFile],
  );

  return (
    <div
      onDragOver={(e) => {
        e.preventDefault();
        setDragging(true);
      }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragging(false);
        handleFiles(e.dataTransfer.files);
      }}
      onClick={() => inputRef.current?.click()}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') inputRef.current?.click();
      }}
      role="button"
      tabIndex={0}
      aria-label="Choose a file or drag it here"
      className={`group flex cursor-pointer flex-col items-center justify-center rounded-2xl border-2 border-dashed px-6 py-16 text-center transition ${
        dragging
          ? 'border-brand-400 bg-brand-500/10'
          : 'border-white/10 bg-ink-900/40 hover:border-brand-400/60 hover:bg-ink-900/60'
      }`}
    >
      <input
        ref={inputRef}
        type="file"
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
      />
      <div className="grid h-16 w-16 place-items-center rounded-2xl bg-brand-500/15 text-3xl text-brand-300 transition group-hover:scale-105">
        ↑
      </div>
      <p className="mt-4 text-lg font-medium text-slate-100">Drop a file to send</p>
      <p className="mt-1 text-sm text-slate-400">
        or click to browse · any size · nothing is uploaded to a server
      </p>
    </div>
  );
}
